import React from "react";
import { Skeleton } from 'primereact/skeleton';
import "../../css/ReportSkeleton.css";

const CashierFraudInnerSkeleton = () => {
    return (
        <div className="reportSkeletonContainer">
            <div className="reportSkeletonInnerContainer">
                <Skeleton animation="wave" height="85px" width="17%"></Skeleton>
                <Skeleton animation="wave" height="85px" width="14%"></Skeleton>
                <Skeleton animation="wave" height="85px" width="42%"></Skeleton>
                <Skeleton animation="wave" height="85px" width="26%"></Skeleton>
            </div>
            {/* <Divider /> */}
            <div className="reportSkeletonInnerContainer">
                <Skeleton animation="wave" height="85px" width="17%"></Skeleton>
                <Skeleton animation="wave" height="85px" width="14%"></Skeleton>
                <Skeleton animation="wave" height="85px" width="42%"></Skeleton>
                <Skeleton animation="wave" height="85px" width="26%"></Skeleton>
            </div>
            {/* <Divider /> */}
        </div>
    )
}

export default CashierFraudInnerSkeleton;